import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 12l-10 0","key":"svg-0"}],["path",{"d":"M14 12l-4 4","key":"svg-1"}],["path",{"d":"M14 12l-4 -4","key":"svg-2"}],["path",{"d":"M20 4l0 3m0 13l0 -3m0 -3.5l0 -3","key":"svg-3"}]]

const IconArrowBarToRightDashed = createReactComponent('outline', 'arrow-bar-to-right-dashed', 'ArrowBarToRightDashed', __iconNode);

export default IconArrowBarToRightDashed;